import type {TextVariantTypes} from "@songfinch/types";

export function useHTMLRender(html: string, baseP: TextVariantTypes = "p-4") {
    const array = [
        {element: "p", class: baseP},
        {element: "h1", class: "h-1"},
        {element: "h2", class: "h-2"},
        {element: "h3", class: "h-3"},
        {element: "h4", class: "h-4"},
        {element: "h5", class: "h-5"},
        {element: "h6", class: "h-6"},
        {element: "blockquote", class: "l-1"},
    ];
  
    let sanitizedHtml = html.replace(/\n/g, "<br />");
    sanitizedHtml = sanitizedHtml.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    const parser = new DOMParser();
    const doc = parser.parseFromString(sanitizedHtml, "text/html");
  
    const hasBlockElements = array.some(({element}) => doc.querySelector(element));
  
    if (!hasBlockElements) {
        const wrapper = doc.createElement("p");
        wrapper.innerHTML = sanitizedHtml;
        doc.body.innerHTML = "";
        doc.body.appendChild(wrapper);
    }
  
    // Add styling classes and normalize to <p>
    array.forEach((tag) => {
        doc.querySelectorAll(tag.element).forEach((element) => {
            const existingClass = element.getAttribute("class") || "";
            element.setAttribute("class", `${existingClass} ${tag.class}`.trim());
  
            if (element.tagName.toLowerCase() !== "p") {
                const newElement = doc.createElement("p");
                Array.from(element.attributes).forEach((attr) => {
                    newElement.setAttribute(attr.name, attr.value);
                });
                newElement.innerHTML = element.innerHTML;
                element.replaceWith(newElement);
            }
        });
    });
  
    // Linkify plain text URLs
    const urlRegex = /\b(?:https?:\/\/|www\.)[^\s<]+[^\s<\.,;:"')\]\s]/g;
  
    function linkifyTextNodes(node: Node) {
        if (node.nodeType === Node.TEXT_NODE) {
            const parent = node.parentElement;
  
            if (parent && parent.tagName.toLowerCase() === "a") return;
  
            const text = node.textContent || "";
            const matches = text.match(urlRegex);
  
            if (matches) {
                const fragment = document.createDocumentFragment();
                let lastIndex = 0;
  
                matches.forEach((url) => {
                    const index = text.indexOf(url, lastIndex);
                    if (index > lastIndex) {
                        fragment.appendChild(document.createTextNode(text.slice(lastIndex, index)));
                    }
  
                    const href = url.startsWith("http") ? url : `https://${url}`;
                    const a = document.createElement("a");
                    a.href = href;
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    a.textContent = url;

                    fragment.appendChild(a);
  
                    lastIndex = index + url.length;
                });
  
                if (lastIndex < text.length) {
                    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
                }
  
                node.replaceWith(fragment);
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            Array.from(node.childNodes).forEach(linkifyTextNodes);
        }
    }
  
    linkifyTextNodes(doc.body);
  
    return {htmlContent: doc.body.innerHTML};
}
  